import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import api from '@/utils/api';
import { toast } from 'sonner';
import { ptDate } from '@/utils/pioneerDates';
import { Button } from '@/components/ui/button';

// Admin, só leitura: lista entrevistas/reuniões com possível fuso errado para confirmação manual.
export const ScheduleAudit = () => {
  const [items, setItems] = useState(null);
  const load = () => api.get('/admin/schedule-audit').then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  const [sending, setSending] = useState(null);
  const flagged = (items || []).filter((i) => i.suspicious);
  const requestConfirmation = async (i) => {
    if (!window.confirm(`Enviar à empresa um pedido para confirmar a hora de "${i.title}"? A marcação não é alterada.`)) return;
    setSending(i.ref);
    try {
      const r = await api.post(`/admin/interviews/${i.ref}/request-time-confirmation`);
      toast.success(`Pedido enviado para ${r.data.sent_to}`);
      setItems((all) => all.map((x) => (x.ref === i.ref ? { ...x, confirmation_requested_at: r.data.requested_at } : x)));
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao enviar o pedido');
    } finally { setSending(null); }
  };
  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="schedule-audit">
      <div className="flex flex-wrap items-center gap-3">
        <AlertTriangle className="h-4 w-4 text-amber-700" />
        <p className="flex-1 text-sm font-semibold text-amber-900">Verificação de fusos (só leitura — nada é alterado)</p>
        <Button size="sm" variant="outline" onClick={load} data-testid="schedule-audit-run">{items ? 'Actualizar' : 'Verificar marcações'}</Button>
      </div>
      {items && (
        <div className="mt-3 space-y-2 text-sm" data-testid="schedule-audit-results">
          <p className="text-amber-900">{flagged.length} marcação(ões) a confirmar de {items.length} verificadas.</p>
          {flagged.map((i) => (
            <div key={`${i.kind}-${i.ref}-${i.start_utc}`} className="rounded-lg border border-amber-200 bg-white p-3" data-testid={`schedule-audit-item-${i.ref}`}>
              <p className="font-semibold text-slate-900">{i.kind}: {i.title} <span className="text-xs font-normal text-slate-500">({i.status})</span></p>
              <p className="text-slate-700">Gravado como <strong>{i.cv_time}</strong> (hora de Cabo Verde)</p>
              <p className="text-xs text-slate-500">A mesma hora noutros fusos: {Object.entries(i.wall_clock_elsewhere).map(([k, v]) => `${k} ${v}`).join(' · ')} — se a pessoa escolheu uma destas horas, foi gravada no fuso errado.</p>
              <p className="text-xs text-amber-700">Motivo: {i.reasons.join('; ')}</p>
              {i.kind === 'entrevista' && (
                <div className="mt-2 flex flex-wrap items-center gap-3">
                  <Button size="sm" onClick={() => requestConfirmation(i)} disabled={sending === i.ref} data-testid={`schedule-audit-request-${i.ref}`}>
                    {i.confirmation_requested_at ? 'Reenviar pedido de confirmação' : 'Pedir confirmação à empresa'}
                  </Button>
                  {i.confirmation_requested_at && <span className="text-xs text-emerald-700" data-testid={`schedule-audit-requested-${i.ref}`}>Pedido enviado a {ptDate(i.confirmation_requested_at)}</span>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
